import React from 'react';
import LeadershipManagementPage from '../leadership/LeadershipManagementPage';
import ReportLayout from './ReportLayout';

export default function LeadershipReportPage() {
  return (
    <ReportLayout
      badge="Leadership"
      title="My Leadership Management Report"
      description="Open your self leadership management assessment and export the current view as PDF."
    >
      <LeadershipManagementPage readOnlyReport />
    </ReportLayout>
  );
}
